import React, { useState, useEffect} from "react";
import "./Schedule.css";
import FadeContent from "../Effects/Fade/FadeContent";
import { sanityClient } from "../../sanity/client";
import { scheduleQuery } from "../../sanity/queries";

const Schedule = () => {
  const [activeDayIndex, setActiveDayIndex] = useState(0);
  const [schedule, setSchedule] = useState(null);

  useEffect(() => {
    sanityClient.fetch(scheduleQuery).then(setSchedule);
  }, []);

  if (!schedule) return null;

  const activeDay = schedule.days[activeDayIndex];

  const formatTime = (time) =>
  `${String(time.hour).padStart(2, "0")}:${String(time.minute).padStart(2, "0")}`;

  return (
    <div className="schedule-container" id="schedule">
      {/* Header */}
      <div className="schedule-header">
        <div className="header-text-wrapper">
        <FadeContent
          blur={false}
          duration={1300}
          easing="ease-out"
          initialOpacity={0}
        >
          <span className="stroke-text">HORARIOS </span>
          <span>DE </span>
          <span className="stroke-text">CLASES</span>
        </FadeContent>

        {/* Animated Orange Line */}
        <div className="header-underline"></div>
        </div>
      </div>

      {/* Tabs */}
      <div className="days-tabs">
        {schedule.days.map((day, index) => (
          <button
            key={day.day}
            className={`day-tab ${index === activeDayIndex ? "active" : ""}`}
            onClick={() => setActiveDayIndex(index)}
          >
            {day.day}
          </button>
        ))}
      </div>

      {/* Content */}
      <div className="schedule-content">
        {activeDay?.sessions?.length ? (
          activeDay.sessions.map((session, sIndex) => (
            <div key={sIndex} className="session-card">
              <div className="session-icon">
                {/* Clock Icon Placeholder - can be replaced with an SVG or FontAwesome icon */}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <circle cx="12" cy="12" r="10"></circle>
                  <polyline points="12 6 12 12 16 14"></polyline>
                </svg>
              </div>

              <div className="session-details">
                <div className="session-info-group">
                  <span className="info-label">Horario</span>
                  <h3 className="info-value">{formatTime(session.start)} - {formatTime(session.end)}</h3>
                </div>

                <div className="separator-arrow">›</div>

                <div className="session-info-group">
                  <span className="info-label">Profesor</span>
                  <h3 className="info-value">{session.trainer.name}</h3>
                </div>

                <div className="separator-arrow">›</div>

                <div className="session-info-group">
                  <span className="info-label">Ubicación</span>
                  <h3 className="info-value">{session.location.name}</h3>
                </div>

                <div className="separator-arrow">›</div>

                <div className="session-info-group">
                  <span className="info-label">Programa</span>
                  <h3 className="info-value">{session.programs.map(p => p.title).join(", ")}</h3>
                </div>
              </div>
            </div>
          ))
        ) : (
          <div className="no-classes">No hay clases este día</div>
        )}
      </div>
    </div>
  );
};

export default Schedule;
